package info.rezident.app.core

@Suppress("UnsafeCastFromDynamic")
object Logger {
    private fun canLog(): Boolean = isLocalEnvironment()

    private val consoleDyn: dynamic = try {
        js("(typeof console !== 'undefined') ? console : null")
    } catch (_: Throwable) {
        null
    }

    private fun call(method: String, args: Array<out Any?>) {
        if (!canLog() || consoleDyn == null) return
        try {
            // Use Function.prototype.apply to spread varargs into dynamic JS call
            consoleDyn[method].apply(consoleDyn, args)
        } catch (_: Throwable) {
            // Best-effort; ignore
        }
    }

    fun log(vararg args: Any?) {
        call("log", args)
    }

    fun info(vararg args: Any?) {
        call("info", args)
    }

    fun debug(vararg args: Any?) {
        call("debug", args)
    }

    fun warn(vararg args: Any?) {
        call("warn", args)
    }

    fun error(vararg args: Any?) {
        call("error", args)
    }
}
